import {
    Chart as ChartJS,
    LinearScale,
    CategoryScale,
    BarElement,
    PointElement,
    LineElement,
    Legend,
    Tooltip,
    LineController,
    BarController,
    Title
  } from 'chart.js';
  
  import { Chart } from 'react-chartjs-2';
  
  ChartJS.register(
    LinearScale,
    CategoryScale,
    BarElement,
    PointElement,
    LineElement,
    Legend,
    Tooltip,
    LineController,
    BarController,
    Title
  );

  interface Dataset {
    label: string;
    data: number[];
    backgroundColor: string;
  }

  interface GenericHorizontalBarchartProps {
    title: string;
    labels: string[];
    datasets: Dataset[];
    stacked?: boolean;
  }
  
  const GenericHorizontalBarchart = ({title, labels, datasets, stacked = false}: GenericHorizontalBarchartProps) => {
    
    // Safety checks to prevent errors when data is not ready
    if (!datasets || !Array.isArray(datasets) || datasets.length === 0) {
      return (
        <div style={{ 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center', 
          height: '100%',
          color: '#999'
        }}>
          Loading chart data...
        </div>
      );
    }

    if (!labels || !Array.isArray(labels) || labels.length === 0) {
      return (
        <div style={{ 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center', 
          height: '100%',
          color: '#999'
        }}>
          No data available for chart
        </div>
      );
    }

    const type = "bar"

    const options = {
    responsive: true,
    indexAxis: 'y' as const, // This makes it horizontal
    scales: {
        x: {
          stacked,
        },
        y: {
          stacked,
        },
      },
    maintainAspectRatio: false,
    plugins: {
        legend: {
          position: 'bottom' as const,
        },
        title: {
          display: true,
          text: title,
        },
      }
    }  
  
    const data = {
      labels,
      datasets,
  };
  
    return (<Chart type={type} data={data} options={options}/>)
  
  }
  
  export default GenericHorizontalBarchart;